import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  // minWidth: 40,
  gap: 0,
};
